import { Component, forwardRef, OnInit, ChangeDetectorRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
export function createCustomInputControlValueAccessor(extendedInputComponent: any) {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => extendedInputComponent),
    multi: true
  };
}

@Component({
  template: ''
})
export class ValueAccessorComponent<T> implements ControlValueAccessor {

  // The internal data model
  innerValue: any = undefined;

  constructor() { }

  onChange: any = () => { }
  onTouch: any = () => { }

  public get value(): T {
    return this.innerValue;
  }

  public set value(val: T) {  // this value is updated by programmatic changes
      this.innerValue = val
      this.onChange(val)
      this.onTouch(val)
      this.afterValueChanged();
  }

  // this method sets the value programmatically
  writeValue(value: any) {
    this.value = value
  }
  // upon UI element value changes, this method gets triggered
  registerOnChange(fn: any) {
    this.onChange = fn
  }
  // upon touching the element, this method gets triggered
  registerOnTouched(fn: any) {
    this.onTouch = fn
  }

  // Para sobrescribir en otras implementaciones
  afterValueChanged(): void {

  };

}
